document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(
    "[id^='shopify-section-template'] .nx-tab-panel"
  );

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const commonParent = button.closest("[id^='shopify-section-template']");

      if (commonParent) {
        const tabButtons = commonParent.querySelectorAll(".nx-tab-panel");
        const tabContents = commonParent.querySelectorAll(".nx-tab-content");
        const index = Array.from(tabButtons).indexOf(button);

        tabButtons.forEach((btn) => {
          btn.classList.remove("active");
        });

        tabContents.forEach((content) => {
          content.classList.remove("active");
        });

        button.classList.add("active");
        tabContents[index].classList.add("active");
      }
    });
  });
});